






import { defineComponent } from '@vue/composition-api';
import home from 'frontend/components/icons/NavbarHomeIcon.vue';
import course from 'frontend/components/icons/NavbarCourseIcon.vue';
import classroom from 'frontend/components/icons/NavbarClassroomIcon.vue';

export default defineComponent({
  props: {
    icon: String,
  },
  setup(props) {
    return {
      iconComponent: props.icon,
    };
  },
  components: {
    home,
    course,
    classroom,
  },
});
